import React, { } from 'react';
import { Checkbox } from '@vtblife/uikit';
import classname from '@search/classname/src';
import './AgentSavedSearchRadioItem.css';

const cn = classname.bind(null, 'AgentSavedSearchRadioItem');

export interface IAgentSavedSearchRadioItem {
    isLike: boolean;
    name: string;
    onChange: () => void;
}

export const AgentSavedSearchRadioItem: React.FC<IAgentSavedSearchRadioItem> = ({ isLike, onChange, name }) => {
    return (<div className={cn()}>
        <Checkbox block onChange={onChange} value={isLike}>{name}</Checkbox>
    </div>);
};

